export default __webpack_public_path__ + "static/media/icon-whishlist.445e802b.svg";